import { FormOption } from '../services/forms.service';

export interface OutputSettings {
  id: number;
  company_id: string;
  output_settings_type: NomenclatureItem;
  title: string;
  description: string;
  timezone_id: number;
  count_used: number;
  formats: OutputSettingsFormat[];
}

export interface OutputSettingsList {
  id: number;
  company_id: string;
  output_settings_type: NomenclatureItem;
  title: string;
  description: string;
  count_used: number;
}

export enum ItemOutputSettingsType {
  COMPANY_DEFAULT = 1,
  NAMED_LIST = 2,
  CUSTOM_OBJECT = 3,
}

interface NomenclatureItem {
  id: ItemOutputSettingsType;
  name: string;
}

export interface OutputSettingsFormat {
  id: number;
  name: string;
  icon_uri: string;
  has_templates: boolean;
  templates: { [key: string]: OutputTemplate | null };
  number_of_posts: number;
  components: Component[];
  properties: Property[];
  property_values: { [key: string]: any[] } | null;
  property_option_values?: {
    [propertyKey: string]: Record<string, any>;
  } | null;
  settings: SettingCategory[];
}

interface Component {
  id: number;
  index: number;
  name: string;
  selected: boolean;
}

export interface Property {
  key: string;
  title: string;
  group_key: string;
  property_order?: number;
  group: {
    label: string;
    order: number;
  };
  data_format: string | null;
  selected: boolean;
  values: FormOption[] | null;
  value?: any | null;
  options?: PropertyOption[];
  option_values?: Record<string, any>;
}

export type PropertyOptionInputType = 'integer' | 'enum' | string;

export interface PropertyOptionChoice {
  name: string;
  value: string | number;
}

export interface PropertyOption {
  key: string;
  label: string;
  input_type: PropertyOptionInputType | null;
  default: any;
  min?: number;
  max?: number;
  choices?: PropertyOptionChoice[];
}

export interface PropertyGroup {
  label: string;
  order: number;
  key: string;
  properties: Property[];
}

interface SettingCategory {
  id: number;
  name: string;
  settings: Setting[];
}

interface Setting {
  id: number;
  name: string;
  type_name: string;
  value_type: string;
  selected: boolean;
  values?: SettingValue[];
  value?: number;
}

interface SettingValue {
  name: string;
  value: number;
}

export interface OutputTemplate {
  id: number;
  file_path: string;
  language_id: number;
  name: string;
  template_path?: string | null;
}
